
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/preferenze",
      function () {
        return require("private-next-pages/dashboard/preferenze.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/preferenze"])
      });
    }
  